"use client";

import CheckCompatibilityModal from "@/components/my-ui/modals/CheckCompatibilityModal";
import CompatibilitySuccessModal from "@/components/my-ui/modals/CompatibilitySuccessModal";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { useTranslations } from "next-intl";
import { useState } from "react";

function CompatibleDeviceSearch() {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState("");
  const [open, setOpen] = useState(false);
  const t = useTranslations(`eSimCompatiblePage.hero`);

  return (
    <>
      <div className="relative max-w-[478px] w-full">
        <Input
          placeholder={t(`searchPlaceholder`)}
          className="w-full rounded-[1.4375rem] bg-background text-muted-foreground shadow"
          onFocus={() => setOpen(true)}
          readOnly
        />
        <Search className="absolute end-3 top-1/2 -translate-y-1/2 transform text-primary" />
      </div>

      {open && (
        <CheckCompatibilityModal
          open={open}
          setOpen={setOpen}
          setShowSuccessModal={setShowSuccessModal}
          setSelectedDevice={setSelectedDevice}
        />
      )}

      <CompatibilitySuccessModal
        showSuccessModal={showSuccessModal}
        setShowSuccessModal={setShowSuccessModal}
        deviceName={selectedDevice}
      />
    </>
  );
}

export default CompatibleDeviceSearch;
